import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Box sx={{ py: 8, backgroundColor: '#fbfbfb' }}>
      <Container maxWidth="lg">
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography 
            variant="h3" 
            component="h1" 
            align="center" 
            gutterBottom
            sx={{ 
              color: '#0a233b',
              fontWeight: 'bold',
              mb: 4
            }}
          >
            Privacy Policy
          </Typography>
          
          <Typography variant="body1" paragraph>
            Last Updated: March 28, 2025
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            1. Introduction
          </Typography>
          <Typography variant="body1" paragraph>
            Welcome to Lantena Property Management ("we," "our," or "us"). We are committed to protecting your privacy and personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            2. Information We Collect
          </Typography>
          <Typography variant="body1" paragraph>
            We may collect personal information that you voluntarily provide to us when you express interest in obtaining information about us or our products and services when you participate in activities on our website or otherwise when you contact us.
          </Typography>
          <Typography variant="body1" paragraph>
            The personal information we collect may include:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>Name and contact information</li>
            <li>Email address and phone number</li>
            <li>Property information</li>
            <li>Account credentials</li>
            <li>Payment information</li>
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            3. How We Use Your Information
          </Typography>
          <Typography variant="body1" paragraph>
            We may use the information we collect for various purposes, including:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>Providing, maintaining, and improving our services</li>
            <li>Processing transactions and sending related information</li>
            <li>Responding to inquiries and offering customer support</li>
            <li>Sending administrative information and updates</li>
            <li>Marketing and promotional communications (with your consent)</li>
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            4. Cookies and Tracking Technologies
          </Typography>
          <Typography variant="body1" paragraph>
            We may use cookies, web beacons, tracking pixels, and other tracking technologies to help customize our website and improve your experience. You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies through your browser settings.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            5. Third-Party Disclosure
          </Typography>
          <Typography variant="body1" paragraph>
            We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties except as described in this Privacy Policy. This does not include trusted third parties who assist us in operating our website, conducting our business, or servicing you, so long as those parties agree to keep this information confidential.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            6. Security Measures
          </Typography>
          <Typography variant="body1" paragraph>
            We implement a variety of security measures to maintain the safety of your personal information. Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            7. Your Rights
          </Typography>
          <Typography variant="body1" paragraph>
            Depending on your location, you may have certain rights regarding your personal information, such as the right to access, correct, delete, or restrict processing of your personal data. Please contact us if you wish to exercise any of these rights.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            8. Changes to This Privacy Policy
          </Typography>
          <Typography variant="body1" paragraph>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            9. Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about this Privacy Policy, please contact us at:
          </Typography>
          <Typography variant="body1" paragraph>
            Lantena Property Management<br />
            Email: privacy@lantena.com<br />
            Phone: (555) 123-4567
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
